import file from "../Markdown/PrivacyPolicy.md";
import React from "react";
import MarkdownPage from "../Layout/MarkdownPage";

function PrivacyPolicy() {
    return (<MarkdownPage title='Polityka Prywatności' file={file} />);
}

export default PrivacyPolicy;